import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseObject } from '../models/response-object.model';

@Injectable({
  providedIn: 'root'
})
export class MayeReportService {

  private url = environment.api + 'api/erp/maye/report';

  constructor(private http: HttpClient) { }

  getOrdersReserved(type: string): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.url}/ordersReserved/${type}`);
  }

  getExistenceByPlace(placeId: number, type: 'excel' | 'pdf' | 'json', endDate: string | null): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.url}/existence-by-place/${placeId}/${type}?endDate=${endDate}`);
  }

  getBalanceByPlaceForWarehouse(startDate: string, endDate: string, type: 'excel' | 'pdf' | 'json'): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.url}/place-warehouse/${type}?startDate=${startDate}&endDate=${endDate}`);
  }

  getBalanceByPlaceForDestination(startDate: string, endDate: string, type: 'excel' | 'pdf' | 'json'): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.url}/place-destination/${type}?startDate=${startDate}&endDate=${endDate}`);
  }

  getResultByPlaceForDestination(startDate: string, endDate: string, type: 'excel' | 'pdf' | 'json'): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.url}/result-place-destination/${type}?startDate=${startDate}&endDate=${endDate}`);
  }

  getClientDestinationBalance(destinationId: number, startDate: string, endDate: string, type: 'excel' | 'pdf' | 'json'): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.url}/client-destination-balance/${destinationId}/${type}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getAdministrativeInvoices(startDate: string, endDate: string, type: string): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.url}/administrative-invoices/${type}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getAdministrativeInvoicesV2(startDate: string, endDate: string, type: string): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.url}/administrative-invoicesV2/${type}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getAdministrativeUnitSold(startDate: string, endDate: string, type: string): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.url}/administrative-unit-sold/${type}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getClientMultiDestinationBalance(data: any, startDate: string, endDate: string, type: 'excel' | 'pdf' | 'json'): Observable<ResponseObject> {
    return this.http.post<ResponseObject>(
      `${this.url}/client-destinations-balance/${type}?startDate=${startDate}&endDate=${endDate}`,
      data
    );
  }

}
